
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { configStore, uiStore } from "@/store/store-accessor";
import AddElement from "@/components/Add/AddElement.vue";
import {
  getNestingRuleFromElementSlug,
  isElementRestrictedToBeChildOrDescendantOfSlug,
  isNestingRuleAllowedInside
} from "@/lib/tree/nesting";
import SearchInput from "@/components/Reusable/CustomInputs/SearchInput.vue";
import {
  getFuzzySearchedElements,
  isElementHidden
} from "@/lib/elements/utils";
import { BuilderElement } from "@/types/elements";
import { AddRegisteredChildrenOptions } from "@/types/controls";

@Component({
  components: { SearchInput, AddElement }
})
export default class AddRegisteredChildrenControl extends Vue {
  @Prop()
  options?: AddRegisteredChildrenOptions;

  search = "";

  get elementsRestrictedToBeChildrenOfThisElementWithSearch() {
    if (!uiStore.activeElement) return [];

    const activeElementSlug = uiStore.activeElement.data.type;

    const validElementsToAdd = Object.values(configStore.elements)
      .filter(element => {
        if (
          !element ||
          isElementHidden(element.addPanelRules, element.settings)
        )
          return false;

        if (
          isElementRestrictedToBeChildOrDescendantOfSlug(
            element,
            activeElementSlug
          )
        ) {
          return true;
        }

        if (
          this.options?.addExtraElementsBySlug.includes(element.slug) &&
          isNestingRuleAllowedInside(
            element.nestingRule,
            getNestingRuleFromElementSlug(activeElementSlug),
            activeElementSlug
          )
        ) {
          return true;
        }

        return false;
      })
      .filter((element): element is BuilderElement => !!element);

    return getFuzzySearchedElements(validElementsToAdd, this.search);
  }

  get state() {
    return configStore.elementsLoadingState;
  }
}
